import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadingNotifications } from "../../../Redux/Slice/NotificationSlice";
import { NewUpdatesStyle } from "../../../Theme";
import { useNavigate } from "react-router";

export default function NewUpdates() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const notificationData = useSelector((state: any) => {
    return { ...state?.NotificationSlice };
  }); //To get data from redux store state

  useEffect(() => {
    dispatch(
      loadingNotifications({
        isNewItems: true,
      })
    );
  }, []);

  if (notificationData.isLoading) {
    return (
      <>
        <Grid item xs={12}>
          <Typography component="div" variant="subtitle1">
            New Updates
          </Typography>
        </Grid>
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          height={"50vh"}
        >
          <CircularProgress color="primary" />
        </Grid>
      </>
    );
  }

  if (notificationData.error) {
    return (
      <>
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          height={"50vh"}
        >
          <Typography
            fontWeight={"bold"}
            fontStyle={"italic"}
            color={"primary"}
          >
            {notificationData.message}
          </Typography>
        </Grid>
      </>
    );
  }

  return (
    <Grid
      container
      item
      xs={12}
      spacing={1}
      alignItems="top"
      justifyContent="center"
    >
      <Grid item xs={12}>
        <Typography component="div" variant="subtitle1">
          New Updates
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <NewUpdatesStyle>
          {notificationData?.AllNotifications?.notSeenNotificationList?.length >
          0 ? (
            notificationData?.AllNotifications?.notSeenNotificationList?.map(
              ({ id, notificationname, createddate }: any) => (
                <Box
                  key={id}
                  onClick={() => {
                    navigate("/notifications");
                  }}
                >
                  <Typography
                    className="date"
                    component="div"
                    color="primary"
                    variant="body2"
                  >
                    {createddate}
                  </Typography>
                  <Typography component="div" color="primary" variant="body1">
                    {notificationname}
                  </Typography>
                </Box>
              )
            )
          ) : (
            <Box>
              <Typography component="div" color="primary" variant="body1">
                No new updates
              </Typography>
            </Box>
          )}
        </NewUpdatesStyle>
      </Grid>
    </Grid>
  );
}
